export function pilotLabel(name: string, playerId: string): string {
  return name === "Пилот"
    ? `${name} · ${playerId.slice(0, 4).toUpperCase()}`
    : name;
}
